// extracted by mini-css-extract-plugin
export default {"spinner":"FeatureTogglesPage_spinner__QeGhz"};